import Abstract from "./../../abstract-view/abstract.js";

import {createElement} from "./../../render/render.js";

const createVideoTemplate = (url) => {
  return (
    `<iframe width="auto" height="auto" src="${url}?showinfo=0&amp;rel=0&amp;autoplay=0" data-autoplay-src="${url}?autoplay=0&amp;showinfo=0&amp;rel=0" frameborder="0" allowfullscreen=""></iframe>`
  );
};

export default class IframeVideo extends Abstract {
  constructor(url) {
    super();

    this._url = url;
  }

  getElement() {
    if (!this._element) {
      this._element = createElement(this._getTemplate());
    }

    return this._element;
  }

  _getTemplate() {
    return createVideoTemplate(this._url);
  }
}
